module.exports = "/_next/static/images/DeliverPersonalization-08ae412a5eff430a6883ea947e2a4ac7.webp";